import cmpWallShow from '../cmp-wall-show'
import consoleLogger from '../../../../modules/console-logger'

const cmpWallPreparations = () => {
  const [consoleLog] = consoleLogger('CMP')
  consoleLog('NOTICE READY', '')

  const startTime = Date.now()

  const interval = setInterval(function () {
    const learnMoreButton = document.getElementById('didomi-notice-learn-more-button')

    if (Date.now() - startTime > 5000) {
      consoleLog('OVERRIDE TIMEOUT', '')
      clearInterval(interval)
      return
    }

    if (!learnMoreButton) {
      return
    }

    clearInterval(interval)

    const buttonContainer = document.querySelector('.didomi-popup-view #buttons')

    if (buttonContainer) {
      const loginLink = document.createElement('span')

      loginLink.textContent = 'Bereits abonniert? Mit s+ einloggen'

      loginLink.style.width = '100%'
      loginLink.style.cursor = 'pointer'
      loginLink.style.display = 'block'
      loginLink.style.textAlign = 'center'
      loginLink.style.marginTop = '10px'
      loginLink.style.marginBottom = '-15px'
      loginLink.style.textDecoration = 'underline'
      loginLink.style.fontWeight = 'bold'

      loginLink.addEventListener('click', () => {
        tp.push([
          'init',
          function () {
            tp.pianoId.show({
              disableSignUp: true,
              displayMode: 'modal',
              screen: 'login',
              showCloseButton: false,

              loggedIn: function () {
                tp.experience.execute()
              },

              loggedOut: function () {},

              close: function () {},
            })
          },
        ])
      })

      buttonContainer.insertAdjacentElement('afterend', loginLink)
    }

    const clonedButton = learnMoreButton.cloneNode(true)

    clonedButton.style.visibility = 'visible'

    learnMoreButton.parentNode.replaceChild(clonedButton, learnMoreButton)

    clonedButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()

        cmpWallShow()
      },
      true,
    )
  }, 200)
}

export default cmpWallPreparations
